import React from "react";
import "./OptionTiles.scss";
import { ArrowRight24 } from "@sia/style-guide";
const OptionTile = ({ title, description, onClick }) => {
  return (
    <div className="sia-padding-02 option-tiles" onClick={onClick}>
      <p className="option-tiles__title">{title}</p>
      <p className="option-tiles__body">{description}</p>
      <ArrowRight24 className={"option-tiles__arrow"} />
    </div>
  );
};

const OptionTiles = ({ options }) => {
  return (
    <div className="option-tiles-container">
      {options.map((option, i) => (
        <OptionTile key={option.title} {...option} />
      ))}
    </div>
  );
};

export default OptionTiles;
